import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { AbstractRtpCorrespondentConfigurationService } from '../abstraction/abstract.rtp-correspondent-configuration.service';
import { IRtpRespondentSettings } from '../../interfaces/configuration/rtp-respondent-settings.interface';
import { IRtpCorrespondentSettings } from '../../interfaces/configuration/rtp-correspondent-settings.interface';
import { IRtpStandaloneSettings } from '../../interfaces/configuration/rtp-standalone-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class RtpCorrespondentConfigurationService extends AbstractRtpCorrespondentConfigurationService {
  private controller = `/manager/rtpconfiguration`;
  private urlGetRtpRespondentSettings = `${environment.apiUrl}${this.controller}/respondentrtpsettings`;
  private urlPostRtpRespondentSettings = `${environment.apiUrl}${this.controller}/respondentrtpsettings`;
  private urlGetRtpCorrespondentSettings = `${environment.apiUrl}${this.controller}/correspondentrtpsettings`;
  private urlPostRtpCorrespondentSettings = `${environment.apiUrl}${this.controller}/correspondentrtpsettings`;
  private urlGetRtpStandaloneSettings = `${environment.apiUrl}${this.controller}/standalonertpsettings`;
  private urlPostRtpStandaloneSettings = `${environment.apiUrl}${this.controller}/standalonertpsettings`;

  constructor(private http: HttpClient) {
    super();
  }

  getRtpRespondentSettings(routingNumber: string): Promise<IRtpRespondentSettings | undefined> {
    return firstValueFrom(
      this.http.get<IRtpRespondentSettings>(`${this.urlGetRtpRespondentSettings}/${routingNumber}`)
    );
  }

  updateRtpRespondentSettings(settings: IRtpRespondentSettings): Promise<IWebMessage | undefined> {
    return firstValueFrom(this.http.post<IWebMessage>(this.urlPostRtpRespondentSettings, settings));
  }

  getRtpCorrespondentSettings(
    routingNumber: string
  ): Promise<IRtpCorrespondentSettings | undefined> {
    return firstValueFrom(
      this.http.get<IRtpCorrespondentSettings>(
        `${this.urlGetRtpCorrespondentSettings}/${routingNumber}`
      )
    );
  }

  updateRtpCorrespondentSettings(
    settings: IRtpCorrespondentSettings
  ): Promise<IWebMessage | undefined> {
    return firstValueFrom(
      this.http.post<IWebMessage>(this.urlPostRtpCorrespondentSettings, settings)
    );
  }

  getRtpStandaloneSettings(routingNumber: string): Promise<IRtpStandaloneSettings | undefined> {
    return firstValueFrom(
      this.http.get<IRtpStandaloneSettings>(`${this.urlGetRtpStandaloneSettings}/${routingNumber}`)
    );
  }

  updateRtpStandaloneSettings(settings: IRtpStandaloneSettings): Promise<IWebMessage | undefined> {
    return firstValueFrom(this.http.post<IWebMessage>(this.urlPostRtpStandaloneSettings, settings));
  }
}
